/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import Localized from '../../../../shared/components/Localized';
import Linkify from 'react-linkify';
import FooterTimeStamp from '../../FooterTimestamp';
import { Wrapper, TitleWrapper, Title, Body } from './styles.js';
import { connect } from 'react-redux';

class Event extends React.Component {
  render() {
    const { feedItem, region, missingTranslations, defaultLocalizations } = this.props;

    const defaultEventTemplate = _.find(defaultLocalizations, {
      'modelName': 'maintenanceEventType',
      'modelKey': feedItem.event.type,
      'modelAttribute': 'template',
    });

    const defaultEventMessage = defaultEventTemplate?.text;

    return (
      <Linkify properties={{ target: '_blank' }}>
      <Wrapper severity={feedItem.severity}>
        <TitleWrapper>
          <div>
            <Title>
              <Localized
                modelName='maintenanceEventType'
                modelKey={feedItem.event.type}
                modelAttribute='label'
                missingTranslations={missingTranslations}
              />
              <span></span>
            </Title>
          </div>
        </TitleWrapper>
        <Body>
          {
            // Only display the message field if it doesn't match the default localization (meaning the user changed it)
            feedItem.event.message !== defaultEventMessage ? <span>{feedItem.event.message}</span> :
            <Localized
              modelName='maintenanceEventType'
              modelKey={feedItem.event.type}
              modelAttribute='template'
              missingTranslations={missingTranslations}
            />
          }
        </Body>
        <FooterTimeStamp
          createdTime= {feedItem.dateTime}
          lastModifiedTime={feedItem.updateTime}
          region= {region}
          missingTranslations={missingTranslations}
        />
      </Wrapper>
    </Linkify>
    );
  }
}

export default connect(
  (state) => ({
    defaultLocalizations: state.requests.defaultLocalizations.value
  })
)(Event);
